import { useActiveConversation } from '../components/chat/ActiveConversationContext';
import { useChatOverlayOpen } from './use-chat-overlay';
import { useSitePaneFits } from './use-site-pane';
import { useEmailReviewFlow, type EmailReviewFlow } from './email-review-store';

export function useEmailReviewPane(): EmailReviewFlow | null {
  const flow = useEmailReviewFlow();
  const chatOpen = useChatOverlayOpen();
  const fits = useSitePaneFits();
  const { activeConversationId } = useActiveConversation();
  if (!flow?.beside || !chatOpen || !fits) return null;
  if (flow.conversationId !== null && flow.conversationId !== activeConversationId) return null;
  if (flow.conversationId === null && activeConversationId !== null) return null;
  return flow;
}
